import styled from "styled-components";

export const StyledBuilderContainer = styled.div`
  background: transparent linear-gradient(160deg, #174d63 0%, #092c3b 100%) 0%
    0% no-repeat padding-box;
  padding: 0;
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  width: 480px;
  flex: 1 0 auto;
  border-radius: 0 0 0 60px;
  overflow: auto;
`;
